// Forward-compat fallback for an unknown `field.type` (step-2 unknown-type
// policy). Renders an inert Bootstrap alert in development so authors notice,
// nothing in production, and warns once per unknown type. A single bad field
// never crashes the surrounding tree.

import type { FieldComponentProps } from '../rendererContext'
import type { RawField } from '../types'

const warned = new Set<string>()

function warnOnce(type: string): void {
  if (warned.has(type)) return
  warned.add(type)
  // eslint-disable-next-line no-console
  console.warn(`[dynamic-form-renderer] unsupported field type ${JSON.stringify(type)} — rendering placeholder`)
}

/** Reset the warn-once cache. Test seam only. */
export function resetUnsupportedWarnings(): void {
  warned.clear()
}

export function UnsupportedField({ field }: FieldComponentProps) {
  const type = String((field as RawField).type ?? 'unknown')
  warnOnce(type)

  const env = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process
    ?.env
  if (env?.NODE_ENV === 'production') return null

  return (
    <div className="alert alert-warning" role="alert">
      Unsupported field type: <code>{type}</code>
      {field.key ? (
        <>
          {' '}
          (<code>{field.key}</code>)
        </>
      ) : null}
    </div>
  )
}
